import UserApi from "../../../api/UserApi";
import OrgApi from "../../../api/OrgApi";
import UserManagementApi from "../../../api/UserManagementApi";
import UserPersistence from "../../../persistence/UserPersistence";
import { MSG_TYPES, setMessage } from "../../../libs/message";
import { menuRouters } from "../../../router/router";
import _ from "../../../libs/utils/ObjectUtils";
import AppPersistence from "../../../persistence/AppPersistence";
import { setRouterTitle } from "../../../libs/combineAuthRouters";
export const moduleId = "zHeader";
export const state = {
  userToggleFlag: false,
  currOrgId: null,
  changeStatus: true,
  headerImgId: '',
  hostnameAddress: '', //主机名字地址
  /*头部加号图标 - 新建账套*/
  openHomePage: '',
  accountVisible: false,
  addAccountType: 'addAccountFromIcon',
  logoutVisible: false,
  buttonData: [],
  toggleFlag: false, //侧边栏展开隐藏
  organizationList: [],  //当前用户可以切换的机构列表（用户）
  changeState: 1,//聊天切换账套操作状态 1：初始状态，2：允许调转,3：不允许跳转
  taxInfo: {},//首页 - 完税情况
  socialSecurity: {},//首页 - 社保情况
  contractInfo: {},//首页 - 合同文件
  invoiceInfo: {},//首页 - 票据管理
  feeInfo: {},//首页 - 费用类型
  voucherNumber: 0,//首页 - 费用类型
};
export const actions = {
  initView({ commit, dispatch }) {
    // dispatch('getMyUserList');
    // dispatch('getUserImg'); // 获取用户信息
    // dispatch('getAccountingList');
  },
  //获取用户头像   储存用户信息
  async getUserImg({ state, commit }) {
    if (sessionStorage.getItem('accountInfo') !== null && sessionStorage.getItem('accountInfo') !== '') {
      let imgDataRes = await UserManagementApi.getUserById({});
      if (imgDataRes.result && imgDataRes.value !== null) {
        let baseInfo = {
          ...UserPersistence.getBaseInfo(),
          user: {
            ...imgDataRes.value,
            name: imgDataRes.value.uname,
            code: imgDataRes.value.ucode,
          }
        };
        UserPersistence.saveBaseInfo(baseInfo);
        commit('setHeaderImgId', imgDataRes.value.img)
      }
    }
  },
  //登出
  async logout({ commit }) {
    let res = await UserApi.logout();
    if (res.result) {
      commit("setLogout", true);
    }
  },
  //设置菜单的展开隐藏
  setWholeOrCurrent(state, data) {
    state.wholeOrCurrent = data;
  },
  // 查询当前用户能修改的机构
  async getMyUserList({ commit }) {
    let res = await UserManagementApi.queryByService({ "serviceId": 1 });
    if (res.result) {
      commit('setOrganizationList', res.value);
    }
  },
  // 获取切换登录机构Token
  async changeUserOrg({ state, commit, dispatch }, id) {
    commit('setChangeStatus', false);
    let res = await UserManagementApi.changeUserOrg({
      userId: id,
      loginType: 1
    });
    if (res.result) {
      UserPersistence.saveToken(res.token);
      location.href = window.location.origin + '/#/login-sso?type=1&token=' + res.token;
      // dispatch('exchangeToken');
    }
  },
  // 切换登录机构
  async exchangeToken({ state, commit, rootState }) {
    let res = await UserApi.exchangeToken(1);
    if (res.result) {
      let baseInfo = {
        ...res.value.user,
        user: {
          id: res.value.user.id,
          name: res.value.user.name,
          usertype: res.value.user.usertype,
        }
      };
      setMessage({
        type: MSG_TYPES.SUCCESS,
        message: '切换成功'
      });
      commit('setChangeStatus', true);
    }
  },
  //切换账套
  async changeChatAccount({ commit, dispatch, rootState }, orgId) {
    commit("setChangeState", 1);
    let initRes = await UserApi.init(orgId);

    if (initRes && initRes.result) {
      let baseInfo = _.cloneDeep(UserPersistence.getBaseInfo());
      let menusRes = await UserApi.getMenus({
        rootServiceId: UserPersistence.getServiceType(),
        userId: UserPersistence.getBaseInfo().user.id,
        orgId: orgId,
      });

      if (menusRes && menusRes.result) {
        if (menusRes.value.length < 1) {
          setMessage({
            type: MSG_TYPES.WARNING,
            message: '用户无权限，请先联系管理员分配权限!'
          });
          // UserPersistence.saveToken(oldToken);
          commit("setChangeState", 3);
          return;
        }
        commit("setChangeState", 2);
        baseInfo = {
          ...baseInfo,
          ...initRes.value,
          menuList: menusRes.value,
        };
        UserPersistence.saveBaseInfo(baseInfo);
        //更新菜单title
        setRouterTitle(menuRouters, menusRes.value);

        rootState.user.menuList = menusRes.value;
        rootState.user.userBaseInfo = baseInfo;
      } else {
        commit("setChangeState", 3);
      }
    } else {
      commit("setChangeState", 3);
    }
  },
  // 新增账套
  async createAccount({ commit, dispatch }, form) {
    let res = await OrgApi.createAccount({
      organizationId: UserPersistence.getBaseInfo().user.orgId,
      ...form
    });
    if (res.result) {
      setMessage({
        type: MSG_TYPES.SUCCESS,
        message: '新增成功!'
      });
      dispatch('user/getAccountingList', null, { root: true });
    }
  },
  // 查询当前用户能修改的机构
  async countByBigClass({ commit },data) {
    let res = await UserApi.countByBigClass(data);
    if (res.result) {
      res.value.map((item)=>{
        if(item.bigClassId === 2001) commit('setContractInfo', item);
        if(item.bigClassId === 2002) commit('setTaxInfo', item);
        if(item.bigClassId === 2003) commit('setSocialSecurity', item);
      })
    }
  },
//  首页查询 票据管理 会计凭证数量
  async queryJournalCount({ commit },data) {
    let res = await UserApi.queryJournalCount(data);
    if (res.result) {
      commit('setInvoiceInfo', res.value)
    }
  },
//   statisticsTotalByPeriod
  async statisticsTotalByPeriod({ commit },data) {
    let res = await UserApi.statisticsTotalByPeriod(data);
    if (res.result) {
      commit('setFeeInfo', res.value)
    }
  },
//
  async queryCollectionVouchersNum({ commit },data) {
    let res = await UserApi.queryCollectionVouchersNum(data);
    if (res.code === 0) {
      commit('setVoucherNumber', res.data)
    }
  },
};
export const mutations = {
  // voucherNumber
  setVoucherNumber(state, data) {
    console.log("data=====",data)
    state.voucherNumber = data;
  },
  setFeeInfo(state, data) {
    state.feeInfo = data;
  },
  setInvoiceInfo(state, data) {
    state.invoiceInfo = data;
  },
  setTaxInfo(state, data) {
    state.taxInfo = data;
  },
  setSocialSecurity(state, data) {
    state.socialSecurity = data;
  },
  setContractInfo(state, data) {
    state.contractInfo = data;
  },
  // 设置切换机构状态
  setUserToggleFlag(state, flag) {
    state.userToggleFlag = flag;
  },
  // 设置当前机构
  setCurrOrgId(state, id) {
    state.currOrgId = id;
  },
  // 设置切换机构请求状态
  setChangeStatus(state, flag) {
    state.changeStatus = flag;
  },
  setHeaderImgId(state, headerImgId) {
    state.headerImgId = headerImgId || ''
  },
  setHostnameAddress(state, hostname) {
    state.hostnameAddress = hostname;
  },

  setCreateAccount(state, data) {
    state.accountVisible = data;
  },
  setGetUserId(state, data) {
    state.openHomePage = data;
  },
  //设置登出状态
  setLogout(state, visible) {
    state.logoutVisible = visible;
  },
  //设置跳转按钮数据
  setToggleFlag(state, data) {
    state.toggleFlag = data;
  },
  // 设置可切换的机构列表
  setOrganizationList(state, list) {
    if (!list) return;
    state.organizationList = list;
  },
  //通过聊天切换账套
  setChangeState(state, status) {
    state.changeState = status;
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/zHeader/index.js